import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=433cc72e&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=433cc72e&prod&lang=scss&scoped=true"
import style1 from "./GlobalSettings.vue?vue&type=style&index=1&id=433cc72e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433cc72e",
  null
  
)

export default component.exports